import { ROOT_GENERATED_DATA_PATH } from "interfaces/models/generateData";

const getUrn = (args: { bimFileId: string; version: string }) => {
  return `${args.bimFileId}?version=${args.version}`;
};

const getRootName = (args: { bimFileId: string; version: string }) => {
  const { bimFileId, version } = args;

  return `${bimFileId.toLowerCase().replace(/[:.,/-]/g, "_")}_v${version}`;
};

const getInstanceTableName = (args: { bimFileId: string; version: string }) => {
  return getRootName(args);
};

export const getRootPath = (args: { bimFileId: string; version: string }) => {
  return `${ROOT_GENERATED_DATA_PATH}/${getRootName(args)}`;
};

export const GenerateForgeDataHelper = {
  getRootName,
  getRootPath,
  getInstanceTableName,
  getUrn,
};
